import { useEffect, useState } from 'react'
import { useFeatureFlag } from '@fs/zion-flags'
import { UPDATE_SPECIFIC_STATE } from '../helpers/dispatch_actions'
import { useAppDispatch } from '../providers/AppRootProvider'

export const useFooterHidden = (hidden = true) => {
  const appDispatch = useAppDispatch()
  useEffect(() => {
    appDispatch({ type: UPDATE_SPECIFIC_STATE, key: 'footer', data: { hidden } })
  }, [appDispatch, hidden])
}

export const usePWAMode = () => {
  const [isPWAMode, setisPWAMode] = useState(false)
  const PWAModeFlag = useFeatureFlag('discovery_familyConnect_viewInPWAMode')
  const storageItem = 'is_standalone_mode'
  const referrerName = 'android-app://org.familysearch.www.together_twa'

  const isInStandaloneMode = () =>
    Boolean(
      (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) || window.navigator.standalone
    )

  useEffect(() => {
    if (sessionStorage.getItem(storageItem) !== 'yes') {
      PWAModeFlag.isOn && setisPWAMode(true)
      !PWAModeFlag.isOn && setisPWAMode(false)
    }
  }, [PWAModeFlag.isOn])

  useEffect(() => {
    // if referrer contains android-twa package name or display-mode is standalone, set sessionStorage item
    // referrer will contain android-twa package name when installed via .apk from Google Play
    // SOURCE CITATION: https://micahjon.com/2021/pwa-twa-detection/

    if (document.referrer.includes(referrerName) || isInStandaloneMode()) {
      setisPWAMode(true)
      sessionStorage.setItem(storageItem, 'yes')
    } else setisPWAMode(sessionStorage.getItem(storageItem) === 'yes')
  }, [])

  return isPWAMode
}
